export default __webpack_public_path__ + "static/media/full-logo.f01a0ac7.png";